import { render, staticRenderFns } from "./brund_castV2.vue?vue&type=template&id=b06319bc&scoped=true&"
import script from "./brund_castV2.vue?vue&type=script&lang=js&"
export * from "./brund_castV2.vue?vue&type=script&lang=js&"
import style0 from "./brund_castV2.vue?vue&type=style&index=0&id=b06319bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06319bc",
  null
  
)

export default component.exports